import { Component, ElementRef, Inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CI_PATHWAY_ADD_DETAIL_PREFIX, CI_PATHWAY_REPORT_LCA_FEEDSTOCK_REGION, CIPathwayApplyPrefix, createCIPathwayReportFacilityNFuelSection } from '@module/ci-pathway-report/ci-pathway-report.const';
import { FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { BaseStepperStepComponent } from '@shared/components/base-stepper/base-stepper-step.component';
import { FormFactoryService } from '@shared/services/form-factory.service';
import { Dialog, DialogModule } from 'primeng/dialog';
import { ViewFacilityDetailsComponent } from '../view-facility-details/view-facility-details.component';
import { ModalService } from '@shared/services/modal.service';
import { IRawFormBase } from '@core/models/raw-form.types';
import { LOOKUP_PATHWAY, LookupService } from '@core/services/lookup.service';
import { IApp } from '@core/models/app.interfaces';
import { documentsTableConfig } from '@module/account-management/account-management.const';
import { AUTO_WIDTH_FOR_COLUMNS, ITableViewConfig, ROWS_PER_PAGE } from '@shared/models/table-view.model';
import { CiPathwayReportService } from '@module/ci-pathway-report/ci-pathway-report.service';
import { UploadDocumentService } from '@shared/services/upload-document.service';
import { BehaviorSubject } from 'rxjs';
import { ServiceMessageComponent } from '@core/components/service-message/service-message.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DEFAULT_DIALOG_CONFIG, SereviceMessageType } from '@core/constants/serviceMessage.const';
import { CARApplyPrefix } from '@module/credit-adjustment-report/const/credit-adjustment-report.const';
import { DocumentUploadInProgressService } from '@shared/services/document-in-progress.service';
import { StoreService } from '@core/store/store.service';
import { TableViewComponent } from '@shared/components/table-view/table-view.component';
import { NgSelectModule } from '@shared/components/ng-select/ng-select.module';
import { CommonModule } from '@angular/common';
import { DocumentsComponent } from '@shared/components/documents/documents.component';
import { WCAGLabelDirective } from '@shared/directives/wcag-label.directive';
import { DisableOnUploadDirective } from '@shared/directives/disable-on-upload.directive';

@Component({
  selector: 'app-add-details-ci-path-report-lca-model',
  templateUrl: './add-details-ci-path-report-lca-model.component.html',
  styleUrls: ['./add-details-ci-path-report-lca-model.component.scss'],
  imports: [FormlyModule, TranslateModule, DialogModule, ReactiveFormsModule, TableViewComponent,
    NgSelectModule, CommonModule, DocumentsComponent, FormsModule, WCAGLabelDirective,
  DisableOnUploadDirective ]
})
export class AddDetailsCiPathReportLcaModelComponent extends BaseStepperStepComponent implements OnInit {
  @ViewChild('dialog', { static: false }) dialog: Dialog;
  @ViewChild('actionTemplate', { static: true }) public actionTemplate: TemplateRef<any>;
  public visible = true;
  public currentStepObj;
  tableConfig: ITableViewConfig;
  staticDocumentsTableData;
  lcaFormLeft = new FormGroup({});
  lcaFormRight = new FormGroup({});
  lcaForm1 = new FormGroup({});
  model: any;
  enableFieldForEditLca = false;
  documentUploadConfig: IApp.IDocumentUploadConfig;
  documentResult1;
  finalDatafromPopUp;
  documentsPage: IApp.IDocumentsPage;
  selectedDocuments;
  feedStockAr;
  pathwayList$ = new BehaviorSubject([]);
  pathwayListLeft$ = new BehaviorSubject([]);
  documentConfig: IApp.IDocumentUploadConfig
  facilityNFuelFieldList: FormlyFieldConfig[];
  feedStockRegionFieldList: FormlyFieldConfig[];
  lca3FieldListLeft: FormlyFieldConfig[];
  lca3FieldListRight: FormlyFieldConfig[];
  lca4FieldListRight: FormlyFieldConfig[];
  lcaSection5List: FormlyFieldConfig[];
  outcome = [];
  public tableActionItems;
  public firstItemIndex = 0;
  feedStockArrayValue = [];
  feedStockFinalVal;
  private pagination = {
    page: 0,
    size: ROWS_PER_PAGE,
  } as IApp.IPagination;

  missingDocsCode = [];
  private feedStockObservable$ = new BehaviorSubject([]);
  documentProgress = false;
  validPathwayIdsOfLeftSide;


  CI_PATHWAY_REPORT_LCA3L: IRawFormBase[] = [
    {
      groupFields: false,
      fieldGroup: [
        {
          type: 'input',
          className: 'col-12',
          key: 'ciApplicationDto.instrumentId',
          label: CIPathwayApplyPrefix('approvedAlphanumeric', CI_PATHWAY_ADD_DETAIL_PREFIX),
          required: true,
          disabled: true,
          id: 'approvedAlphanumericLCA',
        },
        {
          type: 'input',
          className: 'col-12',
          key: 'ciApplicationDto.carbonIntensityFuel',
          label: CIPathwayApplyPrefix('approvedLCACI', CI_PATHWAY_ADD_DETAIL_PREFIX),
          required: true,
          disabled: true,
          id: 'carbonIntensityFuel',
          customTemplateOptions: {
            type: 'formatted-number',
            mask: 'separator.2',
            allowNegativeNumbers: false,
          },
        },
        {
          type: 'input',
          className: 'col-12',
          key: 'ciApplicationDto.additionalCarbonIntensityFuel',
          label: CIPathwayApplyPrefix('approvedAdditionalLCACI', CI_PATHWAY_ADD_DETAIL_PREFIX),
          disabled: true,
          id: 'additionalCarbonIntensityFuel',
          customTemplateOptions: {
            type: 'formatted-number',
            mask: 'separator.2',
            allowNegativeNumbers: false,
          },
        },
        {
          type: 'input',
          className: 'col-12',
          key: 'approvedCarbonIntensity',
          label: CIPathwayApplyPrefix('approvedRoundedLCACI', CI_PATHWAY_ADD_DETAIL_PREFIX),
          required: true,
          disabled: true,
          id: 'approvedCarbonIntensity',
        },
        {
          type: 'dict-select',
          className: 'col-12',
          key: 'ciApplicationDto.feedStock.id',
          id: 'feedStockLCA',
          hideExpression: 'model.ciApplicationDto.type === "CI_CHARGING_STATIONS" || model.ciApplicationDto.type === "CI_FUELING_STATIONS"',
          disabled: true,
          required: true,
          translatePrefix: 'COMMON.feedstockList',
          items: [],
          dataProvided: true,
          label: 'SUBMISSION_MANAGEMENT_MODULE.ci_info.field_1',
          placeholder: 'selectItem',
        },
        {
          key: 'ciApplicationDto.pathwayType',
          type: 'radio',
          className: 'col-12',
          name: 'approvedPathwayType',
          label: 'SUBMISSION_MANAGEMENT_MODULE.applicationApprovalForm.radioOpt3',
          apiOptions: true,
          dummyInputForLabel: true,
          apiService: LOOKUP_PATHWAY,
          id: 'pathwayType',
          disabled: true
        },
        {
          type: 'dict-select',
          className: 'col-12 pathwayId',
          key: 'ciApplicationDto.pathwayIds',
          source: this.pathwayListLeft$,
          label: 'SUBMISSION_MANAGEMENT_MODULE.applicationApprovalForm.dropDown3',
          disabled: true,
          multiple: true,
          id: 'pathwayId',
          requiredExpression: '!(!model.ciApplicationDto.pathwayType || model.ciApplicationDto.pathwayType === "EXISTING")',
          placeholder: 'COMMON.submissionTypeList.selectItem',
        },

      ],
    },
  ];


  lcaSection3: IRawFormBase[] = [{
    groupFields: false,
    fieldGroup: [
      {
        type: 'checkbox',
        className: 'col-12',
        key: 'ciEdited',
        label: CIPathwayApplyPrefix('checkboxToEditCIValues', CI_PATHWAY_ADD_DETAIL_PREFIX),
        disabledExpression: 'model.disabled',
        id: `ciEdited`,
        change: (field, $event) => this.enablingFields($event),
      },
      {
        type: 'input',
        className: 'col-12',
        key: 'instrumentId',
        label: CIPathwayApplyPrefix('approvedAlphanumeric', CI_PATHWAY_ADD_DETAIL_PREFIX),
        disabled: true,
        id: 'instrumentId',
      },
    ],

  }];
  lcaSection4: IRawFormBase[] = [{
    fieldGroup: [
      {
        type: 'input',
        className: 'col-12',
        key: 'actualCarbonIntensity',
        label: CIPathwayApplyPrefix('approvedRoundedLCACI', CI_PATHWAY_ADD_DETAIL_PREFIX),
        required: true,
        id: 'actualCarbonIntensity',
        disabledExpression: 'model.disabled',
        customTemplateOptions: {
          type: 'formatted-number',
          allowNegativeNumbers: false,
            onChange: (event) => {
              this.model = {...this.model}
            },
        },
      },
      {
        type: 'dict-select',
        className: 'col-12',
        key: 'feedStock.id',
        id: 'feedStock',
        hideExpression: 'model.ciApplicationDto.type === "CI_CHARGING_STATIONS" || model.ciApplicationDto.type === "CI_FUELING_STATIONS"',
        required: true,
        translatePrefix: 'COMMON.feedstockList',
        source: this.feedStockObservable$,
        label: 'SUBMISSION_MANAGEMENT_MODULE.ci_info.field_1',
        placeholder: 'selectItem',
        disabledExpression: 'model.disabled',
      },
      {
        key: 'pathwayType',
        type: 'radio',
        className: 'col-12',
        name: 'pathwayType',
        label: 'SUBMISSION_MANAGEMENT_MODULE.applicationApprovalForm.radioOpt3',
        apiOptions: true,
        dummyInputForLabel: true,
        apiService: LOOKUP_PATHWAY,
        id: 'type',
        expressionProperties: {
         // 'templateOptions.disabled': '((model.status === null) || (model.status === "IN_PROCESS"))? false: true',
        },
        onChange: (field, event) => { this.enableOrDisablePathwayList(event) }
      },
      {
        type: 'dict-select',
        className: 'col-12',
        key: 'pathwayIdList',
        multiple: true,
        source: this.pathwayList$,
        label: 'SUBMISSION_MANAGEMENT_MODULE.applicationApprovalForm.dropDown3',
        id: 'pathwayIdList',
        requiredExpression: '!(!model.pathwayType || model.pathwayType === "EXISTING")',
        placeholder: 'COMMON.submissionTypeList.selectItem',
        ignoreDropdownAppend: true,
        disabledExpression: 'model.disabled',
      },
    ],

  }];

  section5: IRawFormBase[] = [
    {
      groupFields: false,
      fieldGroup: [
        {
          className: "rationable",
          type: 'textarea',
          key: 'rationable',
          id: 'rationable',
          label: CIPathwayApplyPrefix('differenceBtwnApprovedActual', CI_PATHWAY_ADD_DETAIL_PREFIX),
          requiredExpression: () => this.checkActualAndApprovedCI(),
          translate: true,
          disabledExpression: 'model.disabled',
          hideExpression: () => !this.fieldsEditable() && !this.model.ciEdited,
          templateOptions: {
            rows: 4,
          }
        }]
    }
  ]




  constructor(@Inject(MAT_DIALOG_DATA) public data,
    private dialogRef: MatDialogRef<AddDetailsCiPathReportLcaModelComponent>,
    public _el: ElementRef,
    private formFactoryService: FormFactoryService,
    private modalService: ModalService,
    public service: CiPathwayReportService,
    public uploadDocumentService: UploadDocumentService,
    private lookupService: LookupService,
    private translateService: TranslateService,
    public documentUploadInProgress: DocumentUploadInProgressService,
    private storeService: StoreService) {
    super();
    this.pageEl = _el;
  }

  get isCurrentLangEnglish() {
    return this.translateService.currentLang === 'en' ? true : false;
  }


  userPermission(){
       if ((this.storeService.user.hasPermission('SAVE_CI_PATHWAY_REPORT') &&
         this.storeService.user.hasPermission('SUBMIT_CI_PATHWAY_REPORT')))
         this.model.hasPermissionVal = true;
        else
         this.model.hasPermissionVal = false;
  }

  checkFormDisabledOrNot() {
    if (((((this.model.status === null) || (this.model.status === "IN_PROCESS") || (this.model.status === "PROPOSED"))
      && this.model.hasPermissionVal)) || (this.storeService.user.roleName === 'ACCOUNT_HOLDER_TRANSACTION_PROPOSER')) {
      this.model.disabled = false;
    }
    else {
      this.model.disabled = true;
    }
  }

  ngOnInit() {
    this.lookupService.getFeedStock().subscribe(res => {
      if (res) {
        this.feedStockAr = res;
      }
    });
    this.model = this.data.currentStepObj;
    this.model.hasPermissionVal = false;
    this.model.disabled = true;
    this.userPermission();
    this.checkFormDisabledOrNot();
     this.documentUploadInProgress.inProgress$.subscribe((value) => this.documentProgress = value);
    if (this.model && this.model.ciApplicationDto && this.model.ciApplicationDto.fuel) {
      if (this.isCurrentLangEnglish) {
        this.model.ciApplicationDto.fuel.name = this.model.ciApplicationDto.fuel.en;
      }
      else {
        this.model.ciApplicationDto.fuel.name = this.model.ciApplicationDto.fuel.fr;
      }
    }
    if(this.model && this.model.feedStock &&  this.model.feedStock.name){
      this.feedStockFinalVal = this.model.feedStock.name;
    }
    if (this.model && this.model.ciApplicationDto.pathwayList && this.model.ciApplicationDto.pathwayList.length && this.model.ciApplicationDto.pathwayIds)
    {
      this.pathwayListLeft$.next(this.model.ciApplicationDto.pathwayList);
      if(this.model.pathwayType === "NEW"){
        this.pathwayList$.next(this.model.pathwayList);
      }
      if(!this.model.ciEdited){
        this.model.pathwayIdList = this.model.ciApplicationDto.pathwayIds;
      }
    }
    if(this.model.pathwayType === "NEW"){
      this.pathwayList$.next(this.model.pathwayList);
    }
    this.facilityNFuelFieldList = this.formFactoryService.configureForm(this.getFacilityNFuelConfig(this.model.ciApplicationDto.type));
    this.feedStockRegionFieldList = this.formFactoryService.configureForm(CI_PATHWAY_REPORT_LCA_FEEDSTOCK_REGION);
    if(this.model && this.model.ciApplicationDto && this.model.ciApplicationDto.feedStock)
    {
      this.feedStockArrayValue = [this.model.ciApplicationDto.feedStock];
      this.CI_PATHWAY_REPORT_LCA3L[0].fieldGroup[4]['items'] = this.feedStockArrayValue;
    }
    this.lca3FieldListLeft = this.formFactoryService.configureForm(this.CI_PATHWAY_REPORT_LCA3L);
    this.lca3FieldListRight = this.formFactoryService.configureForm(this.lcaSection3);
    this.lca4FieldListRight = this.formFactoryService.configureForm(this.lcaSection4);
    this.lcaSection5List = this.formFactoryService.configureForm(this.section5);
    this.lcaForm1.disable();
    this.documentsPage = {
      totalPages: 1,
      last: true,
      first: true,
      size: 20,
      number: 1,
      numberOfElements: 1,
      sort: null,
      content: []
    }
    this.getUploadedDocTypes();
    this.alreadyUploadedDocs(this.pagination);
    this.configStaticDocumentsTable();
    this.setTableActionItems();
    setTimeout(() => {
      if(!this.model.disabled){
        this.lcaForm1.get('pathwayType').enable();
        if(!this.model.ciEdited) {
          this.feedStockObservable$.next(this.feedStockArrayValue);
        }
      }
      else {
        this.lcaForm1.get('pathwayType').disable();
        if(this.model.feedStock){
          let feedStockArrayValue11 = [this.model.feedStock];
          this.feedStockObservable$.next(feedStockArrayValue11);
        }
      }

      if (this.model.pathwayType === 'EXISTING')
        this.lcaForm1.get('pathwayIdList').disable()

      this.model = { ...this.model };
    })
  }

  getFacilityNFuelConfig(type: string): IRawFormBase[] {
  switch (type) {
    case 'CI_CHARGING_STATIONS':
      return createCIPathwayReportFacilityNFuelSection('chargedCIFacility');
    case 'CI_FUELING_STATIONS':
      return createCIPathwayReportFacilityNFuelSection('fuelingCIFacility');
    default:
      return createCIPathwayReportFacilityNFuelSection('approvedCIFacility');
  }
}

  isElectricity()
  {
    if(this.model.ciApplicationDto.type === "CI_CHARGING_STATIONS")
      return true;
    else
      return false;
  }

  isCompressed()
  {
    if(this.model.ciApplicationDto.type === "CI_FUELING_STATIONS")
        return true;
    else
      return false;
  }


  checkActualAndApprovedCI(){
    this.model.actualCarbonIntensity = +this.model.actualCarbonIntensity
    if (this.model.actualCarbonIntensity === this.model.approvedCarbonIntensity)
    {
      return false;
    }
    else
    {
    return true;
    }
  }


  updateDocumentDetails(documentResult: IApp.IEmmitedDocs) {
    if (documentResult.docs.length) {
      this.finalDatafromPopUp = documentResult;
      const filteredData = documentResult.docs.filter(item => item['selectFromPrevious']=== true)
      this.selectedDocuments = filteredData;
      this.outcome = documentResult.docs;
      this.missingDocsCode = documentResult.missingDocsCode;
    }

  }

  reportstatus()
  {
    if(this.model && this.model.status)
    {
      if(((this.model.status === null || this.model.status === "IN_PROCESS" || this.model.status === "PROPOSED")
         && (this.model.hasPermissionVal)) || (this.storeService.user.roleName === 'ACCOUNT_HOLDER_TRANSACTION_PROPOSER')
      )
        return false;
      else
        return true;
    }
  }

  getDocumentConfig(arr): IApp.IDocumentUploadConfig {
    const entityName = 'CI_PATHWAY_REPORT';


    this.documentConfig = {
      id: this.model.id,
      documentType: true,
      entityName,
      disablePaginator: false,
      comment: true,
      statusColumn: true,
      pendingSubmissionStatus: true,
      documentUploadConfigs: arr.map(item=>({
          id: this.model.id,
          documentTypeValue: item.id,
          documentTypeCode: item.code,
          entityName,
          noOfRequiredDocs: 1
      })),
      extraUploadDocuments: [],
      ...(this.service.currentData.resubmitFirstTime && {
        secondaryEntityId: this.service.currentData.parentId,
        secondaryEntityName: entityName
      }),
      metaData: { entityId: this.service.currentData.id, entityStatus: this.service.currentData.status}
    };
    return this.documentConfig;
  }

  scrollToTop(): void {
    setTimeout(() => {
      this.dialog.el.nativeElement.querySelector('.p-dialog-content').scrollTo(0, 0);
    }, 500);
  }

  public close(): void {
    if (this.lcaFormRight.touched || this.lcaForm1.touched) {
      const sub$ = this.service.openConfirmationModal('confirmOnClose').subscribe(result => {
        sub$.unsubscribe();
        if (result) {
          this.dialogRef.close(false);
        }
      });
    } else {
      this.dialogRef.close(false);
    }
  }

  public save() {
    let previouslyUploadedDocuments = [];
    const uniqueDocuments = new Set();
    this.formFactoryService.markFormGroupDirty(this.lcaForm1);
    this.formFactoryService.markFormGroupDirty(this.lcaFormRight);
    if (this.finalDatafromPopUp && this.finalDatafromPopUp.length){
      this.model.prevDocument = this.finalDatafromPopUp;
    }
    if (this.selectedDocuments && this.selectedDocuments.length){
      this.model.selectedDocs = this.selectedDocuments;
    }
    this.service.currentData = { ...this.service.currentData, prevDoc: this.documentResult1, selectedDocs: this.selectedDocuments };
    if (this.selectedDocuments && this.selectedDocuments.length) {
      for (let obj of this.selectedDocuments) {
        if (!uniqueDocuments.has(obj.id)) {
          uniqueDocuments.add(obj.id);
          previouslyUploadedDocuments.push({
            currentEntityId: this.model.id,
            previousEntityId: obj.entityId,
            documentId: obj.id
          });
        }
      }
      this.model.previouslyUploadedDocuments = previouslyUploadedDocuments;
    }
    if(this.model.feedStock && this.model.feedStock.name && (this.enableFieldForEditLca
      || this.model.feedStock.name !== this.model.ciApplicationDto.feedStock.name
      || this.model.feedStock.name !== this.feedStockFinalVal)) {
      this.feedStockAr = this.feedStockAr.filter(item => item.id === this.model.feedStock.id);
      if (!this.feedStockAr.length) {
        this.model.feedStock.name = this.feedStockArrayValue[0].name;
      }
      else {
        this.model.feedStock.name = this.feedStockAr[0].name;
      }
    }

    const pathwayList = this.model.ciApplicationDto.pathwayList || [];
    const validPathways = pathwayList.filter(p => p.value !== "INVALID");

    if( this.model.pathwayType === 'NEW' && !this.model.pathwayIdList?.length && !validPathways?.length){
       this.showErrorMessage('replacedCIPathwayIdNewPathwayIDRequired');
        return;
    }
     
    if ((this.lcaForm1.valid || this.lcaForm1.disabled) && this.lcaFormRight.valid)
    {
      if (this.missingDocsCode.length) {
        this.checkForRequiredDocs(this.missingDocsCode);
        return;
    }
      this.dialogRef.close(this.model);
    }
  }

   public showErrorMessage(message: string, metaData?) {
    return this.modalService
      .open(
        ServiceMessageComponent,
        {
          messages: [
            { message,
              metaData
             },
          ],
          type: SereviceMessageType.ERROR,
        },
        true,
        DEFAULT_DIALOG_CONFIG,
      )
      .afterClosed();
  }


  private checkForRequiredDocs(missingDocs: any) {
    let charCode = 97;
    let missingDocMsg = missingDocs.reduce((acc, doc, index) => {
      ++charCode;
      return index < missingDocs.length - 1
        ? acc + `${this.translateService.instant(`COMMON.documentList.${doc}`)}<br>${String.fromCharCode(charCode)}. `
        : acc + `${this.translateService.instant(`COMMON.documentList.${doc}`)}`;
    }, '');
    const metaData = [`${String.fromCharCode(97)}. ${missingDocMsg}`];
    this.showErrorMessage('mandatoryInformationRequiredForUploadDocs', metaData);
    // this.modalService.open(
    //   ServiceMessageComponent,
    //   {
    //     messages: [
    //       {
    //         message: 'mandatoryInformationRequiredForUploadDocs',
    //         metaData,
    //       },
    //     ],
    //     type: SereviceMessageType.ERROR,
    //   },
    //   true,
    //   DEFAULT_DIALOG_CONFIG,
    // );
  }

  public viewFacilityDetails(event) {
    event && event.preventDefault();
    const data = this.service.currentData.ciApplicationDto;
    let entityData;
    if(this.service.currentData.facilityIdd === this.service.currentData.ciApplicationDto.applicationOrgEntities[0].id)
    {
      entityData = (data.applicationOrgEntities && data.applicationOrgEntities.length) && data.applicationOrgEntities[0];
    }
    else
    {
     entityData = (data.applicationOrgEntities && data.applicationOrgEntities.length) && data.applicationOrgEntities[0].entity;
    }
    if(!entityData.name || (entityData.name !== this.model.facilityName)){
      entityData = (data.applicationOrgEntities && data.applicationOrgEntities.length) && data.applicationOrgEntities[0];
    }
    this.modalService.open(ViewFacilityDetailsComponent, {
      facility: entityData,
      tooltip: CARApplyPrefix('step1_tooltip', '.tooltip')
    }, true).afterClosed();
  }

  configStaticDocumentsTable() {
    const { columns, ...config } = documentsTableConfig;
    const _columns = [
      {
        field: 'name',
        header: 'name',
        width: AUTO_WIDTH_FOR_COLUMNS,
        sortField: 'name',
      },
      {
        field: 'type',
        header: 'type',
        width: AUTO_WIDTH_FOR_COLUMNS,
        translate: true,
        translationPrefix: 'COMMON.documentList',
        sortField: 'type'
      },
      {
        field: 'comments',
        header: 'comments',
        width: AUTO_WIDTH_FOR_COLUMNS,
        sortField: 'comments',
      },
      {
        field: 'status',
        header: 'status',
        width: AUTO_WIDTH_FOR_COLUMNS,
        translationPrefix: 'COMMON.statusList',
        translate: true,
        sortField: 'status'
      },
      {
        field: 'lastModifiedDateStr',
        header: 'timestamp',
        width: AUTO_WIDTH_FOR_COLUMNS,
        sortField: 'lastModifiedDateStr',
      },
      {
        header: 'actions',
        width: AUTO_WIDTH_FOR_COLUMNS,
        templateRef: this.actionTemplate,
      }
    ];



    this.tableConfig = {
      ...config,
      ...{ columns: _columns },
    };
  }

  private setTableActionItems() {
    this.tableActionItems = [
      {
        id: 'DOWNLOAD',
        name: this.translateService.instant('CARBON_INTENSITY_PATHWAY_REPORT.reportDetails.DOWNLOAD'),
      },
    ];
  }

  public async triggerTableAction(event, rowIndex, rowData) {
    setTimeout(() => {
      rowData.dummyModel = null;
    });
    if (!event) {
      return;
    }
    switch (event.id) {
      case 'DOWNLOAD':
          this.uploadDocumentService.download(rowData.id);

        }
  };

  enablingFields(event) {
    if (event.target.checked) {
      this.enableFieldForEditLca = true;
      if(this.model.status === null || this.model.status === "IN_PROCESS" || this.model.status === "PROPOSED"){
        this.lcaForm1.enable();
         this.lookupService.getFeedStock().subscribe(res => {
          if(res) {
            this.feedStockObservable$.next(res);
          }
         });
        if(this.model && this.model.feedStock && this.model.feedStock.id){
         this.lcaForm1.controls['feedStock'].setValue({id: this.model.feedStock.id})
        }
      }
      this.model.ciEdited = true;
      if(this.model.pathwayType === 'NEW'){
        this.pathwayList$.next(this.model.pathwayList);
      }
      setTimeout(() => {
      if (this.model.pathwayType === 'EXISTING')
      {
        this.lcaForm1.get('pathwayIdList').disable();
        this.lcaForm1.get('pathwayIdList').updateValueAndValidity();
        this.model = {...this.model};
      }
    });
       this.lcaSection5List = this.formFactoryService.configureForm(this.section5);

    }
    else {
      this.enableFieldForEditLca = false;
      this.model.ciEdited = false;
      this.lcaForm1.controls['actualCarbonIntensity'].setValue(this.model.approvedCarbonIntensity);
      this.lcaForm1.controls['pathwayType'].setValue(this.model.ciApplicationDto.pathwayType);
      this.pathwayIdListForRightForm();
      if(this.model.ciApplicationDto && this.model.ciApplicationDto.feedStock && this.model.ciApplicationDto.feedStock.id)
      {
        this.feedStockObservable$.next(this.feedStockArrayValue);
        this.lcaForm1.disable();
      }
       this.lcaSection5List = this.formFactoryService.configureForm(this.section5);
      this.lcaForm1.disable();
      this.lcaForm1.updateValueAndValidity();

      this.model = {...this.model};
    }
  }

  pathwayIdListForRightForm() {
    const pathwayList = this.model.ciApplicationDto.pathwayList || [];
    const validPathways = pathwayList.filter(p => p.value !== "INVALID");

    if (validPathways.length === 0) {
      this.pathwayList$.next([]);
      this.lcaForm1.controls['pathwayIdList'].setValue(null);
    } else {
      this.pathwayList$.next(validPathways);
      if (this.model.ciApplicationDto.pathwayType === "NEW" && this.model.ciApplicationDto.pathwayIds) {
        this.validPathwayIdsOfLeftSide = this.model.ciApplicationDto.pathwayIds.filter(id => validPathways.some(p => p.id === id));
        this.lcaForm1.controls['pathwayIdList'].setValue(this.validPathwayIdsOfLeftSide);
      }
    }

  }

  fieldsEditable() {
    return this.enableFieldForEditLca;
  }

  alreadyUploadedDocs(pagination) {
    const entityType = 'APPLICATION';
    const metaData = [{
      "metaData": {"REPORT_TYPE":"CI_PATHWAY_REPORT"}
      }];

    const entityId = this.model.ciApplicationDto.id
    this.uploadDocumentService.getAll(pagination, entityId, entityType, undefined, undefined, null, null, metaData ).
      subscribe(response => {
        this.staticDocumentsTableData = response;
      })
  }

  onPaginationChanged(pagination: IApp.IPagination) {
    this.pagination = pagination;
    this.firstItemIndex = (this.pagination.page * this.pagination.size);
    this.alreadyUploadedDocs(this.pagination);
  }

  enableOrDisablePathwayList(data) {
    if (data.target.defaultValue === 'EXISTING')
    {
      this.pathwayList$.next([]);
      this.lcaForm1.get('pathwayIdList').disable();
      this.lcaForm1.get('pathwayIdList').clearValidators();
      this.lcaForm1.controls['pathwayIdList'].setValue(null);
    }
    else
    {
      this.pathwayList$.next(this.model.pathwayList);
      this.lcaForm1.get('pathwayIdList').enable();
      if( this.validPathwayIdsOfLeftSide && this.model.ciApplicationDto.pathwayIds)
      {
        this.lcaForm1.controls['pathwayIdList'].setValue(this.validPathwayIdsOfLeftSide);
      }
    }
    this.model = {...this.model};
  }

  getUploadedDocTypes() {
    this.uploadDocumentService.getUploadedDocTypes({
      id: this.model.ciApplicationDto.id,
      entityName:'APPLICATION',
    }).subscribe(result => {
      this.documentUploadConfig = this.getDocumentConfig(result.filter(doc => doc.code !== 'OTHER'));
    });
  }



}
